import React from 'react';
import { Button, Card, CardBody, CardImg, Input, UncontrolledCollapse, Row, Col } from 'reactstrap';
import { DashLg, PlusLg } from 'react-bootstrap-icons';
import { isSuperAdmin } from '../utils/helpers';

const superAdmin = isSuperAdmin();

const Product = ({ data, qty, onChange, digitalCardsAvailable }) => (
  <Card className="product mt-3">
    <CardBody>
      <div className="d-flex">
        <CardImg
          src={`https://www.golfamore.com/assets/img/products/${data.image}`}
          className="mr-2 d-none d-sm-block"
          style={{ width: '30%', height: '30%' }}
        />
        <Row style={{ flex: 1 }}>
          <Col xs="12" sm="6" className="d-flex justify-content-center">
            <div className="d-flex flex-column justify-content-center">
              <h3 className="font-weight-bold mb-0">{data.name}</h3>
              <h4 style={{ color: '#2dce89', fontWeight: 'bold' }}>
                {data.priceCustomer} {data.currency}
              </h4>
              <Button
                color="link"
                className="p-0 m-0"
                id={`description${data.id}`}
                style={{ textAlign: 'left' }}
              >
                {/* <InfoCircle style={{ fontSize: '1em', marginTop: '-2px' }} /> Läs mer */}
              </Button>
            </div>
          </Col>
          <Col xs="12" sm="6" className="d-flex justify-content-center">
            <div className="d-flex flex-grow-1 flex-column justify-content-center">
              {data.subProducts?.map((sp) => (
                <div key={sp.id} className="d-flex flex-row justify-content-end">
                  <div className="d-flex align-items-center buttons">
                    {(superAdmin || !sp.digital || digitalCardsAvailable) && (
                      <>
                        <h4
                          className="pr-2 mb-0"
                          data-product-code={sp.code}
                          data-product-id={sp.id}
                          data-product-currency={data.currency}
                          data-product-digital={sp.digital}
                        >
                          {sp.name}
                        </h4>

                        <Button
                          color="success"
                          onClick={() => onChange(sp.id, +1)}
                          className="mr-0"
                        >
                          <PlusLg />
                        </Button>
                        <Input type="text" readOnly value={qty[sp.id] || 0} className="qty" />
                        <Button onClick={() => onChange(sp.id, -1)} disabled={qty[sp.id] === 0}>
                          <DashLg />
                        </Button>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </div>
      <div>
        <UncontrolledCollapse toggler={`#description${data.id}`}>
          <Card>
            <CardBody>Mer information</CardBody>
          </Card>
        </UncontrolledCollapse>
      </div>
    </CardBody>
  </Card>
);

export default Product;
